enum TimeRange {
  WEEK = 'week',
  MONTH = 'month',
  ALL_TIME = 'allTime'
}

export default TimeRange
